<template>
    <b-row class="m-0 pl-3 pr-5 pb-3">
        <line-chart v-if="!(this.depName == 'Mantenimiento' ||this.depName == 'Vigueta'  ||this.depName == 'Insulpanel' || this.depName == 'Bono Garantía' )" class="mb-3" suffix=" m3" title="Producción" :colors="['#fd832d']"  :download="true"  :data="[[chartProduccionFecha[0],chartProduccion[0]],[chartProduccionFecha[1],chartProduccion[1]],[chartProduccionFecha[2],chartProduccion[2]],[chartProduccionFecha[3],chartProduccion[3]],[chartProduccionFecha[4],chartProduccion[4]],[chartProduccionFecha[5],chartProduccion[5]],[chartProduccionFecha[6],chartProduccion[6]],[chartProduccionFecha[7],chartProduccion[7]]]" ></line-chart>
        <column-chart  :dataset="{borderWidth: 100}"
        prefix="$" thousands="," title="Bonos" color='#005cc3' :download="true"   :data="[[chartBonosFecha[0],chartBonos[0]],[chartBonosFecha[1],chartBonos[1]],[chartBonosFecha[2],chartBonos[2]],[chartBonosFecha[3],chartBonos[3]],[chartBonosFecha[4],chartBonos[4]],[chartBonosFecha[5],chartBonos[5]],[chartBonosFecha[6],chartBonos[6]],[chartBonosFecha[7],chartBonos[7]]]" ></column-chart>
    </b-row>         
</template>

<script>
import {mapActions} from 'vuex';

export default {
    name: 'Graphics',
     computed:{
        depName() {
            return this.$store.getters["admin/getDep"];
        },
        cityName(){
            return this.$store.getters['admin/getName'];
        },
        chartBonos(state){
            return this.$store.getters['plants/chartBonos'];
        },
        chartBonosFecha(state){
            return this.$store.getters['plants/chartBonosFecha'];
        },
        chartProduccion(state){
            return this.$store.getters['plants/chartProduccion'];
        },
        chartProduccionFecha(state){
            return this.$store.getters['plants/chartProduccionFecha'];
        }

    },
    mounted(){
         let city = this.$store.getters["plants/getHistoryCity"]
         
        this.$store.dispatch('plants/getBonos', {
                cityName: city,
                depName: 'Corte'
        });
        this.$store.dispatch('plants/getProduccion', {
                cityName: city,
                depName: 'Corte'
        });
    },
    methods:{
        ...mapActions('plants', ['getBonos']),
        ...mapActions('plants', ['getProduccion']),
    }
}
</script>

<style scoped>
.graphs{
    width: 100%;
}
</style>